export default {
  '关键字':'关键字',
  '请输入名称关键字':'请输入名称关键字',
  '新增计划':'新增计划',
  '管理人员':'管理人员',
  '已选':'已选',
  '清空':'清空',
  '计划名称':'计划名称',
  '个性化训练周期':'个性化训练周期',
  '持续时长':'持续时长',
  '天':'天',
  '个性化训练人数':'个性化训练人数',
  '是否删除':'是否删除',
  '删除后该计划不可再查看':'删除后该计划不可再查看',
  '删除成功。':'删除成功。',
  '是否提前结束':'是否提前结束',
  '结束后立即生效':'结束后立即生效',
  '结束成功。':'结束成功。',
  '操作成功。':'操作成功。',
  '人员不能为空！':'人员不能为空！',
  '请选择班级':'请选择班级',

  '计划日期':'计划日期',
  '运动日期':'运动日期',
  '学生姓名':'学生姓名',
  '年级':'年级',
  '强度':'强度',
  '个':'个',
  '秒':'秒',
  '填写基本信息':'填写基本信息',
  '配置运动项目':'配置运动项目',
  '发布个性化训练计划':'发布个性化训练计划',
  '查看个性化训练计划':'查看个性化训练计划',
  '编辑个性化训练计划':'编辑个性化训练计划',
  '请添加项目！':'请添加项目！',
  '编辑成功':'编辑成功',
  '新增成功':'新增成功',
  '返回后数据不会保存':'返回后数据不会保存',
  '基础信息':'基础信息',
  '复制其他计划':'复制其他计划',
  '请选择':'请选择',
  '请输入计划名称，1~20个字':'请输入计划名称，1~20个字',
  '选择图标':'选择图标',
  '图标':'图标',
  '参训人员':'参训人员',
  '添加':'添加',
  '请输入描述':'请输入描述',
  '请输入计划名称':'请输入计划名称',
  '请选择图标':'请选择图标',
  '请选择参训人员':'请选择参训人员',
  '配置项目':'配置项目',
  '周期':'周期',
  '共计':'共计',
  '天':'天',
  '暂无':'暂无',
  '个项目':'个项目',
  '当前选中日期':'当前选中日期',
  '添加项目':'添加项目',
  '复制其他日期':'复制其他日期',
  '选择复制日期':'选择复制日期',
  '请选择日期':'请选择日期',
  '选择项目':'选择项目',
  '运动方式':'运动方式',
  '支持特殊项目':'支持特殊项目',
  '分':'分',
  '秒':'秒',

  '请选择运动项目':'请选择运动项目',
  '请填写运动强度':'请填写运动强度',
  '运动强度填写错误':'运动强度填写错误',

  '项目名':'项目名',
  '运动强度':'运动强度',
  '周一':'周一',
  '周二':'周二',
  '周三':'周三',
  '周四':'周四',
  '周五':'周五',
  '周六':'周六',
  '周日':'周日',

  '请选择周期':'请选择周期',
  '是否清空本日项目':'是否清空本日项目',
  '所选日期没有数据！':'所选日期没有数据！',

  '用户列表':'用户列表',
  '未开始':'未开始',
  '进行中':'进行中',
  '已结束':'已结束',

  '确认要返回吗？':'确认要返回吗？',
}